import axios from 'axios'
import observer from '../observer'
import { HILEIA_HTTP_RETCODE } from '../constant'
import { getErrMsg, ResponseError, TransformError } from './error'
import i18n from '@/i18n/index.js'

function checkCode(code, msg) {
  if (code === HILEIA_HTTP_RETCODE.Ok) {
    return
  }
  const respErr = new ResponseError(code, msg || i18n.tc('home.UnknownMistake'))
  switch (code) {
    // 未登录
    case HILEIA_HTTP_RETCODE.UserNotLogined:
    // 签名校验失败
    case HILEIA_HTTP_RETCODE.SignatureCheckFailed:
    // token校验失败
    case HILEIA_HTTP_RETCODE.TokenCheckFailed:
      observer.$emit('logout', respErr)
      break
    case HILEIA_HTTP_RETCODE.OperationFailed:
    // 操作失败
    case HILEIA_HTTP_RETCODE.NOGRANT:
    // 未授权应用
    default:
  }
  throw respErr
}

const hileiaHttp = axios.create({
  withCredentials: true
})

hileiaHttp.interceptors.response.use(
  resp => {
    const conf = resp.config
    const resData = resp.data
    const code = resData?.code || 0
    const msg = resData?.msg || ''

    checkCode(code, msg)

    if (conf.isTransformRequestResult === false) {
      return resData
    }

    return resData.data
  },
  error => {
    // 最后的错误收集处理
    if (error?.response && axios.isAxiosError(error)) {
      let { status, statusText, data } = error.response

      if (data) {
        const { code, msg } = data
        if (code) {
          status = code
        }

        if (msg) {
          statusText = msg
        }
      }

      return Promise.reject(new TransformError(status, statusText || getErrMsg(status)))
    }
    return Promise.reject(new Error(i18n.tc('home.NetworkErrorTryAgain')))
  }
)

export default hileiaHttp
